"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageBusService = /** @class */ (function () {
    function MessageBusService() {
        this.eventTarget = document.createElement('div');
        this.eventTarget.id = MessageBusService.NAMESPACE;
    }
    MessageBusService.prototype.on = function (type, listener) {
        var _this = this;
        this.eventTarget.addEventListener(type, listener);
        return {
            type: type,
            removeListener: function () {
                _this.eventTarget.removeEventListener(type, listener, false);
            },
        };
    };
    MessageBusService.prototype.emit = function (type, detail) {
        return this.eventTarget.dispatchEvent(new CustomEvent(type, { detail: detail }));
    };
    MessageBusService.NAMESPACE = 'mf-message-bus';
    return MessageBusService;
}());
exports.default = MessageBusService;
